export const config: Config = {
  localStorageTokenName: "access-token",
  siteUrl: process.env.PUBLIC_URL || window.location.origin + "/onedrivestatus",
  oneDrive: {
    appId: "ab979077-1781-439c-9962-c8849daa3e5f",
    scope:
        // eslint-disable-next-line max-len
        "Files.Read.All offline_access Files.ReadWrite.All Files.ReadWrite Files.ReadWrite.AppFolder Files.ReadWrite.Selected Files.Read.Selected",
    baseUrl: "https://graph.microsoft.com/v1.0"
  }
};
  
export interface Config {
    localStorageTokenName: string;
    siteUrl: string;
    oneDrive: {
      appId: string;
      scope: string;
      baseUrl: string;
    };
  }
  